import type { ReactNode } from 'react';
import { Button } from '../../shared/ui/Button';
import { formatSince, type SessionSlot } from './session';

const centered = {
  display: 'grid',
  placeItems: 'center',
  minHeight: '100vh',
  background: 'var(--color-background)',
} as const;

function Screen({ title, children, actions }: { title: string; children: ReactNode; actions: ReactNode }) {
  return (
    <div style={centered}>
      <div style={{ display: 'grid', gap: '1rem', textAlign: 'center', maxWidth: '28rem', padding: '2rem' }}>
        <h1 style={{ fontSize: '1.25rem', margin: 0 }}>{title}</h1>
        <p style={{ margin: 0, color: 'var(--color-text-secondary)' }}>{children}</p>
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>{actions}</div>
      </div>
    </div>
  );
}

export function SessionConflictScreen({
  slot, since, onResolve,
}: { slot: SessionSlot; since: number; onResolve: (takeOver: boolean) => void }) {
  const onde = slot === 'celular' ? 'outro celular' : 'outro computador';
  return (
    <Screen
      title="Sessão em uso"
      actions={
        <>
          <Button onClick={() => onResolve(true)}>Desconectar o outro e entrar</Button>
          <Button variant="ghost" onClick={() => onResolve(false)}>Cancelar</Button>
        </>
      }
    >
      Esta conta já está conectada em {onde}
      {since > 0 ? ` desde ${formatSince(since)}` : ''}. Para entrar aqui, o outro será desconectado.
    </Screen>
  );
}

export function SessionDisplacedScreen({ onSignOut }: { onSignOut: () => void }) {
  return (
    <Screen
      title="Sua conta foi conectada em outro dispositivo"
      actions={<Button onClick={onSignOut}>Entrar novamente</Button>}
    >
      Por segurança, só um aparelho de cada tipo fica conectado por vez.
    </Screen>
  );
}

export function SessionErrorScreen({ onRetry, onSignOut }: { onRetry: () => void; onSignOut: () => void }) {
  return (
    <Screen
      title="Não foi possível verificar a sessão"
      actions={
        <>
          <Button onClick={onRetry}>Tentar novamente</Button>
          <Button variant="ghost" onClick={onSignOut}>Sair</Button>
        </>
      }
    >
      Verifique sua conexão e tente de novo.
    </Screen>
  );
}
